<script lang="ts" setup>
  import { useDrawer } from '@/stores/drawer';
  import { onMounted, onBeforeUnmount, ref } from 'vue';

  const drawer = useDrawer();

  const isLoading = ref(true);
  const slideDelay = ref(80);

  function preventScroll(event: Event): void {
    event.preventDefault();
  }

  onMounted(() => {
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => {
      isLoading.value = false;
    }, slideDelay.value);
  });

  onBeforeUnmount(() => {
    isLoading.value = true;
    document.documentElement.style.overflow = 'auto';
  });
</script>

<template>
  <div
    class="drawer"
    @scroll="preventScroll"
  >
    <Transition name="right-slide">
      <div
        v-if="!isLoading"
        class="drawer__content"
      >
        <component
          :is="drawer.state.component"
          v-bind="drawer.state.props"
          v-on="drawer.state.listeners || {}"
        />
      </div>
    </Transition>
  </div>
</template>

<style lang="postcss" scoped>
  .drawer {
    @apply fixed left-0 top-0;
    @apply h-screen w-screen;
    @apply bg-black bg-opacity-30;
    @apply flex items-center justify-end;
    @apply overflow-hidden;
    z-index: 150;
    max-height: 100vh;

    .drawer__content {
      @apply h-full min-h-full;
      @apply w-full max-w-xl;

      z-index: 200;
      max-height: calc(100vh - 180px);

      @media (min-width: 768px) {
        max-height: calc(100vh - 82px);
      }
    }
  }
</style>
